import styled, { css } from 'styled-components'

import { mq, sizes } from '../../theme'
import A from '../A'
import ActionButton from '../ActionButton'
import HeaderSearch from '../HeaderSearch'
import Icon from '../Icon'

export const Container = styled.nav<{ isOpen?: boolean }>`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  max-width: 100vw;
  overflow-x: hidden;
  z-index: ${({ theme }) => theme.zIndexes.header + 1};
  background: ${({ theme }) => theme.colors.pureWhite};
  transform: ${({ isOpen }) =>
    isOpen ? 'translateX(0%)' : 'translateX(100%)'};
  transition: transform 0.3s ease-in-out;

  @media ${mq(sizes.desktop)} {
    display: none;
  }
`

export const TopBar = styled.div`
  display: grid;
  place-items: center;
  grid-template-columns: 1fr 3.5rem;
  column-gap: 2.5rem;
  padding: 2rem;
  background: ${({ theme }) => theme.colors.pureWhite};
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 0.2rem;
    background-color: ${({ theme }) => theme.colors.wildSand};
  }
`

export const SearchPicto = styled(Icon)`
  width: 1.4rem;
  height: 1.4rem;
  color: ${({ theme }) => theme.colors.pureBlack};
`

export const ToggleSearch = styled.button`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 3.5rem;
  background: ${({ theme }) => theme.colors.pureWhite};
  width: 100%;
  border-radius: 1.75rem;
  border: solid 1px ${({ theme }) => theme.colors.greyCE};
  padding: 0 1.5rem;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.08);
  cursor: pointer;
`
export const SearchText = styled.div`
  ${({ theme }) => theme.textStyles.text_bold_condensed_16}
  margin-left: 1rem;
`

export const SearchFormContainer = styled.div<{ isSearchVisible?: boolean }>`
  position: absolute;
  min-height: 20rem;
  box-shadow: 0 7px 24px 0 rgba(0, 0, 0, 0.13);
  border-radius: 0 0 4rem 4rem;
  background: ${({ theme }) => theme.colors.pureWhite};
  z-index: 1;
  inset: 0 0 auto;
  padding: 4rem 2rem;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-100%);
  transition: transform 150ms ease-out, opacity 150ms ease-out;
  ${({ isSearchVisible }) =>
    isSearchVisible &&
    css`
      opacity: 1;
      pointer-events: auto;
      transform: none;
    `}
`
export const CloseSearchButton = styled(ActionButton)`
  position: absolute;
  inset: 1.6rem 1.6rem auto auto;
`

export const SearchHeading = styled.div`
  ${({ theme }) => theme.textStyles.text_bold_24}
  text-align: center;
  margin-bottom: 4.5rem;
`

export const SearchForm = styled(HeaderSearch)``

export const Search = styled.input`
  background: none;
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.alto};
  flex-grow: 1;
  margin-right: 2rem;
  height: 3rem;

  &::placeholder {
    color: ${({ theme }) => theme.colors.pureBlack};
    ${({ theme }) => theme.textStyles.text_14};
  }
`
export const Close = styled.div``

export const Menu = styled.div<{ currentMenuLevel: number }>`
  display: flex;
  flex-direction: row;
  transform: ${({ currentMenuLevel }) =>
    `translateX(-${currentMenuLevel * 100}%)`};

  transition: transform 0.3s ease-in-out;
`

export const Links = styled.ul<{ $level?: number }>`
  padding: ${({ $level }) =>
    $level === 2 || $level === 3
      ? '0rem 2.25rem 0rem 2.5rem'
      : '0rem 1.25rem 0rem 1.5rem'};
  list-style: none;
`

export const LevelLinkItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ theme }) => theme.colors.greenEmerald};
`

export const LinkItem = styled.li<{ $level?: number }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: ${({ $level }) => ($level === 2 ? '0.5rem 0rem' : '1.5rem 0rem')};
`

export const LevelCta = styled.button`
  margin-right: 0rem;
  background: none;
  flex-shrink: 0;
  padding: 1rem;
  color: ${({ theme }) => theme.colors.pureBlack};
`

export const LevelText = styled(A)`
  ${({ theme }) => theme.textStyles.text_bold_condensed_15}
  text-decoration: underline;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-color: ${({ theme }) => theme.colors.greenEmerald};
  text-decoration-thickness: 0.4rem;
  text-underline-position: under;
  color: ${({ theme }) => theme.colors.greenEmerald};
  width: 100%;
`

export const LinkText = styled(A)`
  ${({ theme }) => theme.textStyles.text_bold_condensed_15}
  width: 100%;
  text-decoration: none;
  margin-right: 2rem;
  text-align: left;

  &:only-child {
    margin-right: 6rem;
  }
`

export const LinkCta = styled.button`
  background: none;
  flex-shrink: 0;
  padding: 1rem;
`
export const CtaIcon = styled(Icon)`
  display: flex;
  width: 1.75rem;
  height: 1.75rem;
`

export const LevelCommon = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  width: 100vw;
  flex-shrink: 0;
`

export const LevelOne = styled(LevelCommon)`
  ${Links} {
    padding: 1.5rem 1.25rem 0rem 1.5rem;
  }

  ${LinkItem} {
    &:last-of-type {
      margin-top: 3rem;
      &:before {
        content: '';
        position: absolute;
        left: 0;
        width: 100vw;
        height: 0.2rem;
        transform: translateY(-3.5rem);
        background-color: ${({ theme }) => theme.colors.wildSand};
      }
    }
  }
`

export const Pushes = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 4rem 2rem;
  background: ${({ theme }) => theme.colors.wildSand};
`

export const Meta = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.pureWhite};
  justify-content: space-between;
  align-items: center;
`

export const MetaDivider = styled.div`
  width: 100%;
  height: 0.1rem;
  background: ${({ theme }) => theme.colors.divider};
`

export const YourAccount = styled(A)`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  padding: 2.5rem;
  padding-bottom: 1.5rem;
`
export const YourAccountIcon = styled(Icon)`
  display: flex;
  width: 3.5rem;
  height: 3.5rem;
  padding: 1rem;
  color: ${({ theme }) => theme.colors.pureWhite};
  background: ${({ theme }) => theme.colors.pureBlack};
  border-radius: 50%;
`
export const YourAccountText = styled.div`
  margin-left: 1.5rem;
`
export const SocialButton = styled(ActionButton)``
export const Socials = styled.div`
  padding: 2.5rem;
  padding-top: 1.5rem;
  ${SocialButton} {
    &:not(:first-child) {
      margin-left: 1.5rem;
    }
  }
`

export const Push = styled(A)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1.2rem 1.7rem;
  margin-top: 1.5rem;
  width: 100%;
  border-radius: 3rem;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  border: 1px solid ${({ theme }) => theme.colors.greenEmerald};
  ${({ theme }) => theme.textStyles.text_bold_condensed_14};
  text-decoration: none;

  &:first-of-type {
    margin-top: 0rem;
  }
`

export const LevelTwo = styled(LevelCommon)`
  ${LevelText} {
    ${({ theme }) => theme.textStyles.text_bold_condensed_18}
  }

  ${LinkText} {
    text-transform: none;
    ${({ theme }) => theme.textStyles.text_medium_16}
  }
`

export const PushBlock = styled.div`
  display: flex;
  position: relative;
  width: 100%;

  & > * {
    // NavPush
    display: flex;
    flex-grow: 1;
  }
`

export const LevelThree = styled(LevelCommon)`
  ${LevelText} {
    ${({ theme }) => theme.textStyles.text_medium_18}
    text-transform: none;
    line-height: 2.4rem;
  }

  ${LinkText} {
    text-transform: none;
    ${({ theme }) => theme.textStyles.text_medium_16}
  }
`

export const BackButton = styled(ActionButton)`
  margin: 3rem 0 2.5rem 0;
`
